<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a href="https://github.com/akashbadone" title="Github" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a href="https://www.linkedin.com/in/akashbadone/" title="LinkedIn" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
            <li>
                <a href="https://g.dev/akashbadone" title="Google Developers" target='_blank'>
                    <i class="fab fa-google"></i>
                </a>
            </li>
            <li>
                <a href="https://learn.microsoft.com/en-us/users/akashbadone/" title="Microsoft Learn" target='_blank'>
                    <i class="fab fa-microsoft"></i>
                </a>
            </li>
            <li>
                <a href="https://www.hackerrank.com/profile/akashbadone" title="HackerRank" target='_blank'>
                    <i class="fab fa-hackerrank"></i>
                </a>
            </li>
            <li>
                <a href="https://www.credly.com/users/akashbadone" title="Credly by Pearson" target='_blank'>
                    <img src="/assets/images/achievements/credly.svg" style="width: 40px;filter: grayscale(100%);" alt="Credly by Pearson">
                </a>
            </li>
            <li>
                <a href="https://www.holopin.io/@akashbadone#badges" title="Holopin" target='_blank'>
                    <img src="/assets/images/achievements/holopin.png" style="width: 30px;filter: grayscale(100%);" alt="Holopin">
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a href="mailto:akashbadone0@gmail.com" target='_blank'>akashbadone0&#64;gmail.com </a>
        </div>
    </div>

    <!-- <div class="footer-credits text-center" >
        <a href="https://github.com/andresjosehr/andresjosehr-portfolio" target="_blank" rel="nofollow noopener noreferrer">
            <div>Built with Angular by Jose Andres</div>
        </a>
        <a href="https://github.com/bchiang7/v4" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Designed by Brittany Chiang</div>
        </a>
    </div> -->

</footer>